import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsFootball = ({
    color,
    opacity = '1',
    fillOpacity = '1',
    size = 20,
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox={`0 0 ${size} ${size}`}>
        <path
            d={
                'M7.56253 17.4792C6.90975 17.5486 6.12156 17.5313 5.19795 17.4271C4.27434 17.3229 3.56948 17.1528 3.08336 16.9167C2.88892 16.4722 2.72573 15.7778 2.59378 14.8334C2.46184 13.8889 2.43059 13.0834 2.50003 12.4167L7.56253 17.4792ZM9.5417 17.1459L2.83336 10.4375C3.06948 9.39586 3.41323 8.44794 3.86461 7.59377C4.316 6.73961 4.84031 6.00697 5.43753 5.39586C6.03475 4.79863 6.76045 4.28127 7.61461 3.84377C8.46878 3.40627 9.38892 3.07641 10.375 2.85419L17.125 9.60419C16.9028 10.632 16.5764 11.5764 16.1459 12.4375C15.7153 13.2986 15.2014 14.0278 14.6042 14.625C13.9792 15.2361 13.2327 15.7604 12.3646 16.1979C11.4966 16.6354 10.5556 16.9514 9.5417 17.1459ZM7.83336 13.3334L13.3334 7.83336L12.1667 6.66669L6.6667 12.1667L7.83336 13.3334ZM17.4584 7.62502L12.3959 2.52086C13.0625 2.43752 13.882 2.45141 14.8542 2.56252C15.8264 2.67363 16.5139 2.84725 16.9167 3.08336C17.1667 3.63891 17.3403 4.35766 17.4375 5.23961C17.5348 6.12155 17.5417 6.91669 17.4584 7.62502Z'
            }
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
